import { render } from "./ConfirmationDialog.vue?vue&type=template&id=2cee3bd5&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=2cee3bd5&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cee3bd5"]])

export default __exports__